export default function GeneralContentContainer({children}){
    return <div className="lg:min-h-screen w-full grid lg:grid-cols-2 sm:grid-cols-1">
        {children}
    </div>
}